// extracted by mini-css-extract-plugin
module.exports = {"Text":"Text_Text__1aHew","Value":"Text_Value__1t26S","Small":"Text_Small__2VUsV","Unit":"Text_Unit__banXJ"};